import module from 'prestamosExternos/module.js'
import template from './template.html'
import moment from 'moment'

export class PrestamosExternosLista {
  fechaInicial = null
  fechaFinal = null
  conceptoId = null
  estatus = null
  data = {
    fechaInicial: null,
    fechaFinal: null,
    conceptoId: null,
    estatus: 1,
  }
  resultados = null
  buscando = false
  exportando = false
  catalogo = {
    estatus: [
      {id: 1, descripcion: 'Activo'},
      {id: 2, descripcion: 'Inactivo'},
      {id: 3, descripcion: 'Concluído'},
    ],
    conceptos: [
      {id: null, concepto: 'Todos los conceptos'},
    ],
  }

  constructor ($location, PrestamosExternosConceptos, PrestamosExternosAbonos, PrestamosExternosReporte) {
    this.$location = $location
    this.PrestamosExternosConceptos = PrestamosExternosConceptos
    this.PrestamosExternosAbonos = PrestamosExternosAbonos
    this.PrestamosExternosReporte = PrestamosExternosReporte
  }

  $onChanges (changes) {
    if (changes.fechaInicial || changes.fechaFinal || changes.conceptoId || changes.estatus) {
      this.data.fechaInicial = this.fechaInicial
      this.data.fechaFinal = this.fechaFinal
      this.data.conceptoId = this.conceptoId
      this.data.estatus = this.estatus
      this.cargarResultados()
    }
  }

  $onInit () {
    this.$promise = this.PrestamosExternosConceptos.get()
      .then(({data}) => (this.catalogo.conceptos = [...this.catalogo.conceptos, ...data]))
  }

  buscar () {
    this.$location.replace()
    this.$location.search({
      fecha_inicial: this.data.fechaInicial ? moment(this.data.fechaInicial).format('YYYY-MM-DD') : null,
      fecha_final: this.data.fechaFinal ? moment(this.data.fechaFinal).format('YYYY-MM-DD') : null,
      concepto_id: this.data.conceptoId,
      estatus: this.data.estatus,
    })

    this.cargarResultados()
  }

  cargarResultados () {
    if (this.buscando) return

    this.buscando = true

    this.PrestamosExternosAbonos.get(this.data.fechaInicial, this.data.fechaFinal, this.data.conceptoId, this.data.estatus)
      .then(({data}) => (this.resultados = data))
      .finally(() => (this.buscando = false))
  }

  exportar () {
    if (this.exportando) return

    this.exportando = true

    this.PrestamosExternosReporte.get(this.data.fechaInicial, this.data.fechaFinal, this.data.conceptoId, this.data.estatus)
      .then(({data}) => (data.save()))
      .finally(() => (this.exportando = false))
  }
}

module.component('prestamosExternosLista', {
  controller: PrestamosExternosLista,
  template,
  bindings: {
    fechaInicial: '<',
    fechaFinal: '<',
    conceptoId: '<',
    estatus: '<',
  },
})



// WEBPACK FOOTER //
// ./src/prestamosExternos/components/lista/component.js